import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { applyPortalTheme } from "@/lib/portalTheme";

/**
 * Sets `data-portal` on `<html>` so CSS tokens switch between internal (ops)
 * and client (chapter-facing) palettes. Must render inside `<BrowserRouter>`.
 */
export function PortalThemeScope() {
  const { pathname } = useLocation();

  useEffect(() => {
    applyPortalTheme(pathname);
  }, [pathname]);

  return null;
}
